import React, { Component } from 'react';
import { compose } from 'recompose';
import { withSnackbar } from 'notistack';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { IconButton, Button } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { removeSnackbar, setShowErrorListModal, setPostAcqWorkflowGridStateUpdate } from 'store/actions';
import { Fragment } from 'react';

class AppNotifier extends Component {
  displayed = [];  // this is to store notifications that have been displayed

  storeDisplayed = (id) => {
    this.displayed = [...this.displayed, id];
  };

  onViewDetailsClicked = () => {
    this.props.setShowErrorListModal(true)
  }

  shouldComponentUpdate({ notifications: newSnacks = [] }) {
    // if notifications from new prop is empty then don't update component -- this will happen when user/program removes notifications from redux store, and thus we igore those changes and prevent component update.
    if (!newSnacks.length) {
      this.displayed = [];
      return false;
    }

    // get current notifications from old props
    const { notifications: currentSnacks } = this.props;

    // loop through new notifications and compare them with existing notifications one by one
    for (let i = 0; i < newSnacks.length; i += 1) {
      const newSnack = newSnacks[i];
      // if any notification is already in dismissed status, we close and remove it from store
      if (newSnack.dismissed) {
        this.props.closeSnackbar(newSnack.key);
        this.props.removeSnackbar(newSnack.key);
      }

      // return true if any new notification doesn't exist in current notifications
      if (!currentSnacks.filter(({ key }) => newSnack.key === key).length) return true;
    }

    return false;
  }

  componentDidUpdate() {
    const { notifications = [], setPostAcqWorkflowGridStateUpdate, history } = this.props;

    notifications.forEach(({ key, message, options = {}, actions = {} }) => {
      const newOptions = {...options};
      const { showDetailsButton, disableClose } = newOptions

      if (!disableClose) {
        newOptions.action = key => (
          <IconButton
            color='inherit'
            onClick={() => this.props.closeSnackbar(key)}
          >
            <CloseIcon style={{ fontSize: 20 }} />
          </IconButton>
        )
      }

      if (newOptions.variant === 'error') {
        newOptions.persist = true;
        newOptions.action = key => (
          <>
            {showDetailsButton &&
              <Button
                variant='outlined'
                color='inherit'
                onClick={this.onViewDetailsClicked}
              >
                Details
              </Button>
            }
            {!disableClose && 
              <IconButton
                color='inherit'
                onClick={() => this.props.closeSnackbar(key)}
              >
                <CloseIcon style={{ fontSize: 20 }} />
              </IconButton>
            }
          </>
        );
      }
      if(actions?.additionalAction) {
        let additionalAction = actions.additionalAction;
        if (actions.additionalAction.type === 'viewOnWorkflow') {
          const { route, filterValue } = actions.additionalAction;
          additionalAction = () => {
            return (
              <Button
                variant='outlined'
                size='small'
                color='inherit'
                onClick={() => {
                  setPostAcqWorkflowGridStateUpdate({ filterValue, columnMods: [{ field: 'id', type: 'sortOrder', value: 'asc' }] }, true);
                  history.push(route);
                  this.props.closeSnackbar(key)
                }}
              >
                View on Workflow
              </Button>
            )
          }
        }
        newOptions.action = key => (
        <Fragment>
          {additionalAction()}
          {!disableClose &&
            <IconButton color='inherit' onClick={() => { this.props.closeSnackbar(key) }}>
              <CloseIcon style={{ fontSize: 20 }} />
            </IconButton>
          }
        </Fragment>
        )
      }
      // Do nothing if snackbar is already displayed
      if (this.displayed.includes(key)) return;
      // Display snackbar using notistack
      this.props.enqueueSnackbar(message, {
        ...newOptions,
        onClose: (event, reason, key) => {
          if (newOptions.onClose) {
            newOptions.onClose(event, reason, key);
          }
          // When snackbar is being closed, also dispatch action to remove snackbar from redux store
          this.props.removeSnackbar(key);
        }
      });
      // Keep track of snackbars that we've displayed
      this.storeDisplayed(key);
    });
  }

  render() {
    return null;
  }
}

const mapStateToProps = state => ({
  notifications: state.appState.appNotifications
});

const mapDispatchToProps = {
  removeSnackbar,
  setShowErrorListModal,
  setPostAcqWorkflowGridStateUpdate
};


export default withSnackbar(compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(AppNotifier));
